var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.validationResult && _vm.item.validationResult.message)?_c('div',{staticClass:"validation-message",class:("status--" + _vm.status),domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }